import React, { forwardRef } from 'react';
import useAdapter from '../hooks/useAdapter';

function Adapter({ component, children, forwardedRef, ...props }) {
  const adapter = useAdapter();
  const Component = adapter.get(component);

  return (
    <Component {...props} ref={forwardedRef}>
      {children}
    </Component>
  );
}

export default forwardRef((props, ref) => <Adapter {...props} forwardedRef={ref} />);
